/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import React from 'react';
import { Segment as S, Icon } from 'semantic-ui-react';

const styleFunc = ({ noMargin = false }) => ({
    container: {
        boxShadow: 'none',
        margin: noMargin ? '0px' : '1rem',
        border: 'none',
        borderRadius: '12px',
    },
    title: {
        position: 'absolute',
        borderRadius: '12px 12px 0 0',
        left: 0,
        top: 0,
        fontSize: '20px',
        lineHeight: '44px',
        width: '100%',
        height: '44px',
        color: '#0c3454',
        backgroundColor: 'rgba(12, 52, 84, 0.12)',
        paddingLeft: '1rem',
        fontWeight: 'bold',
    },
    arrow: {
        position: 'absolute',
        top: 0,
        right: '1rem',
        color: '#0c3454',
        fontWeight: 'bold',
        cursor: 'pointer',
    },
});

class Segment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hidden: false,
        };
    }

    toggle = () => {
        this.setState({ hidden: !this.state.hidden });
    };

    render() {
        const { children, title, style = {}, ...rest } = this.props;
        const { hidden = false } = this.state;
        const styles = styleFunc(this.props);

        return (
            <S
                {...rest}
                style={{
                    ...styles.container,
                    ...style,
                    maxHeight: hidden ? '44px' : 'initial',
                    overflow: hidden ? 'hidden' : 'initial',
                }}
            >
                <If condition={title}>
                    <div style={styles.title}>
                        {title}
                        <Icon style={styles.arrow} name={hidden ? 'angle right' : 'angle down'} onClick={this.toggle} />
                    </div>
                    <div style={{ height: '44px' }} />
                </If>
                {children}
            </S>
        );
    }
}

export default Segment;
